import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { AccountResponse } from '../model/models'

export class AuthAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.authorize = this.authorize.bind(this)
  }

  public authorize(email: string, password: string): Promise<AccountResponse> {
    const endpoint = `/auth/login/`
    return this.post<AccountResponse, { username: string; password: string }>(endpoint, {
      username: email,
      password,
    })
      .then((response: AxiosResponse<AccountResponse>) => response.data)
      .catch((error) => Promise.reject(error))
  }

  public triggerPasswordReset(email: string): Promise<{}> {
    const endpoint = `/user/trigger_password_reset_email/`
    return this.post<{}, { email: string }>(endpoint, { email })
  }

  public resetPassword(email: string, password: string, token: string): Promise<{}> {
    const endpoint = `/user/reset_password_from_email/`
    return this.post<{}, { email: string; password: string; token: string }>(endpoint, {
      email,
      password,
      token,
    })
  }
}

export const authAPI = new AuthAPI(httpConfig)
